import api from './api';

function cleanParams(params = {}) {
  const normalized = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    normalized[key] = value;
  });
  return normalized;
}

export async function getDektalNotifications(params = {}) {
  const { data } = await api.get('/dektal-notifications', {
    params: cleanParams(params),
  });
  return data;
}

export async function getDektalNotificationsUnreadCount() {
  const { data } = await api.get('/dektal-notifications/unread-count');
  return data;
}

export async function markDektalNotificationRead(notificationId) {
  const { data } = await api.post(`/dektal-notifications/${notificationId}/read`);
  return data;
}

export async function dismissDektalNotification(notificationId) {
  const { data } = await api.post(`/dektal-notifications/${notificationId}/dismiss`);
  return data;
}

export async function snoozeDektalNotification(notificationId, payload = {}) {
  const { data } = await api.post(`/dektal-notifications/${notificationId}/snooze`, payload);
  return data;
}

export async function markDektalNotificationActionClicked(notificationId, payload = {}) {
  const { data } = await api.post(`/dektal-notifications/${notificationId}/action-clicked`, payload);
  return data;
}

export async function generateCurrentDektalNotifications() {
  const { data } = await api.post('/dektal-notifications/generate-current');
  return data;
}
